import { useMemo } from "react";

import EventCheckbox from "../EventCheckbox";

import { Webhook } from "@/types";

type EventGroupProps = {
  group: string;
  events: string[];
  webhook: Webhook;
  handleEventChange: (event: string, isChecked: boolean) => void;
  disabled: boolean;
};

const EventGroup = ({ group, events, webhook, handleEventChange, disabled }: EventGroupProps) => {
  const eventGroup = useMemo(() => {
    return events.map((event) => (
      <EventCheckbox
        key={event}
        event={event}
        checked={webhook.events.includes(event)}
        onChange={handleEventChange}
        disabled={disabled}
      />
    ));
  }, [events, webhook.events, handleEventChange, disabled]);

  return (
    <div className="mb-4">
      <h3 className="mb-2 text-sm font-medium text-gray-700">{group}</h3>
      <div className="pl-4">{eventGroup}</div>
    </div>
  );
};

export default EventGroup;
